import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <div className="stage-grid absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200/70 text-foreground-500">
          <i className="ri-radar-line text-2xl" aria-hidden="true" />
        </span>
        <p className="mt-6 font-label text-6xl font-bold text-background-300 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这路信号没有找到
        </h1>
        <p className="mt-2 break-all text-xs text-foreground-500">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          页面可能已经归档或链接有误。回到首页或直播大厅，继续查看正在回传的现场实时画面。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/live"
            className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-500/60 hover:text-primary-500"
          >
            <i className="ri-live-line" aria-hidden="true" />
            进入直播大厅
          </Link>
        </div>
      </div>
    </div>
  );
}